/**
 * @desc 退件签收
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.OutReturnSignRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/outMaster/signing`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
